import {ApolloClient, InMemoryCache, createHttpLink} from "@apollo/client";

export const bootstrapClient = new ApolloClient({
    link: createHttpLink({
        uri: "/api/graphql",
    }),
    cache: new InMemoryCache(),
});
